import { getCryptoIconUrl } from "@/lib/cryptoIcons";

// Города выдачи наличных. Наличие в конкретном городе подтверждает оператор,
// поэтому список здесь — только для выбора в форме заявки.
// Страны и популярные города для выдачи наличных.
// Россия первая — выбрана по умолчанию, её список городов прежний.
export const CASH_COUNTRIES = [
    {
        name: "Россия",
        cities: [
            "Москва",
            "Санкт-Петербург",
            "Новосибирск",
            "Екатеринбург",
            "Казань",
            "Нижний Новгород",
            "Челябинск",
            "Самара",
            "Ростов-на-Дону",
            "Краснодар",
            "Сочи",
            "Тюмень",
        ],
    },
    { name: "Беларусь", cities: ["Минск", "Гомель", "Брест", "Витебск", "Гродно", "Могилёв"] },
    { name: "Казахстан", cities: ["Алматы", "Астана", "Шымкент", "Караганда", "Актобе"] },
    { name: "Узбекистан", cities: ["Ташкент", "Самарканд", "Бухара", "Андижан"] },
    { name: "Кыргызстан", cities: ["Бишкек", "Ош"] },
    { name: "Армения", cities: ["Ереван", "Гюмри", "Ванадзор"] },
    { name: "Грузия", cities: ["Тбилиси", "Батуми", "Кутаиси"] },
    { name: "Азербайджан", cities: ["Баку", "Гянджа"] },
    { name: "Турция", cities: ["Стамбул", "Анталья", "Аланья", "Измир", "Анкара", "Мерсин"] },
    { name: "ОАЭ", cities: ["Дубай", "Абу-Даби", "Шарджа"] },
    { name: "Таиланд", cities: ["Бангкок", "Пхукет", "Паттайя"] },
];

export const CASH_DEFAULT_COUNTRY = CASH_COUNTRIES[0].name;

// Быстрые суммы для варианта «отдаю наличные».
export const CASH_QUICK_AMOUNTS_RUB = [5000, 10000, 25000, 50000];

export const SUPPORTED_ASSETS = [
    {
        currency: "USDT",
        name: "Tether",
        icon: getCryptoIconUrl("USDT"),
        network: "TRC20" // Default or primary network recommendation
    },
    {
        currency: "USDC",
        name: "USD Coin",
        icon: getCryptoIconUrl("USDC"),
        network: "ERC20"
    },
    {
        currency: "TON",
        name: "Toncoin",
        icon: getCryptoIconUrl("TON"),
        network: "TON"
    },
    {
        currency: "SOL",
        name: "Solana",
        icon: getCryptoIconUrl("SOL"),
        network: "SOL"
    },
    {
        currency: "TRX",
        name: "TRON",
        icon: getCryptoIconUrl("TRX"),
        network: "TRC20"
    },
    {
        currency: "BTC",
        name: "Bitcoin",
        icon: getCryptoIconUrl("BTC"),
        network: "BTC"
    },
    {
        currency: "ETH",
        name: "Ethereum",
        icon: getCryptoIconUrl("ETH"),
        network: "ERC20"
    },
];
